module.exports = __webpack_public_path__ + "img/s2.e91b7f9f.jpg";